// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_project_model from "./web_project_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function account_picker(source, send) {
  const partial_arg = "Choose a GitHub account";
  const partial_arg$1 = Signal.map((function (p) {
    return p.install_url !== "";
  }), source);
  const partial_arg$2 = "No eligible GitHub accounts on this page. Install the App or continue to the next page.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    if (p.loading) {
      return false;
    } else {
      return Caml_obj.caml_equal(p.accounts, /* [] */ 0);
    }
  }), source);
  const partial_arg$6 = Signal.map((function (p) {
    return p.accounts;
  }), source);
  const partial_arg$7 = Signal.map((function (p) {
    return p.account_page !== undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___004_) {
      const partial_arg = {
        TAG: /* Project_setup */ 32,
        _0: /* Refresh */ 1
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (p) {
        return p.loading;
      }), source)));
      const partial_arg$3 = "ghost";
      const partial_arg$4 = "Refresh GitHub accounts";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$7, (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___005_) {
          const partial_arg = {
            TAG: /* Project_setup */ 32,
            _0: /* More_accounts */ 2
          };
          const partial_arg$1 = (function (param) {
            return Lui_elements.press(send, partial_arg, param);
          });
          const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (p) {
            return p.loading;
          }), source)));
          const partial_arg$3 = "ghost";
          const partial_arg$4 = "More GitHub accounts";
          return function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$8 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$9 = "wrap";
  const partial_arg$10 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$1, (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___003_) {
          const partial_arg = "Install GitHub App";
          const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (p) {
            return p.install_url;
          }), source)));
          return function (param, param$1) {
            return Lui_elements.link(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.keyed(partial_arg$6, (function (a) {
            return a.id;
          }), Stdlib__String.compare, (function (param) {
            const account = Signal.sample(param);
            return function (param$1, param$2) {
              return Lui_elements.scoped((function (__lui_context___001_) {
                const partial_arg = {
                  TAG: /* Project_setup */ 32,
                  _0: {
                    TAG: /* Choose_account */ 3,
                    _0: account
                  }
                };
                const partial_arg$1 = (function (param) {
                  return Lui_elements.press(send, partial_arg, param);
                });
                const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
                  return p.loading;
                }), source)));
                const partial_arg$3 = "outline";
                const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (a) {
                  return a.account;
                }), param)));
                return function (param, param$1) {
                  return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param$1, param$2);
            };
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.row(undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, partial_arg$8, param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$11 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$12 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
  };
}

function repository_picker(source, send) {
  const partial_arg = "Choose a repository you administer";
  const partial_arg$1 = "No eligible repositories on this page. Check the App installation and your repository administration permission.";
  const partial_arg$2 = "muted";
  const partial_arg$3 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$4 = Signal.map((function (p) {
    if (p.loading) {
      return false;
    } else {
      return Caml_obj.caml_equal(p.repositories, /* [] */ 0);
    }
  }), source);
  const partial_arg$5 = Signal.map((function (p) {
    return p.repositories;
  }), source);
  const partial_arg$6 = Signal.map((function (p) {
    return p.repository_page !== undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$4, partial_arg$3, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.keyed(partial_arg$5, (function (r) {
          return r.id;
        }), Stdlib__String.compare, (function (param) {
          const repository = Signal.sample(param);
          return function (param$1, param$2) {
            return Lui_elements.scoped((function (__lui_context___002_) {
              const partial_arg = {
                TAG: /* Project_setup */ 32,
                _0: {
                  TAG: /* Choose_repository */ 5,
                  _0: repository
                }
              };
              const partial_arg$1 = (function (param) {
                return Lui_elements.press(send, partial_arg, param);
              });
              const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
                return p.loading;
              }), source)));
              const partial_arg$3 = "outline";
              const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (r) {
                return r.full_name;
              }), param)));
              return function (param, param$1) {
                return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param$1, param$2);
          };
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$6, (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___006_) {
              const partial_arg = {
                TAG: /* Project_setup */ 32,
                _0: /* More_repositories */ 3
              };
              const partial_arg$1 = (function (param) {
                return Lui_elements.press(send, partial_arg, param);
              });
              const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (p) {
                return p.loading;
              }), source)));
              const partial_arg$3 = "ghost";
              const partial_arg$4 = "More repositories";
              return function (param, param$1) {
                return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }), param, param$1);
        }),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$7 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$8 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, param, param$1);
  };
}

function branch_field(source, send) {
  const partial_arg = "Base branch";
  const partial_arg$1 = "muted";
  const partial_arg$2 = "New templates use this branch. Existing sessions keep their source.";
  const partial_arg$3 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___007_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, (function (branch) {
            return {
              TAG: /* Project_setup */ 32,
              _0: {
                TAG: /* Branch */ 8,
                _0: branch
              }
            };
          }), param);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (p) {
          return p.pending;
        }), source)));
        const partial_arg$2 = "Base branch";
        const partial_arg$3 = "Repository default";
        const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (p) {
          return p.branch;
        }), source)));
        return function (param, param$1) {
          return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$4 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$5 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, param, param$1);
  };
}

function confirmation(source, send) {
  const partial_arg = "Project name";
  const partial_arg$1 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___009_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, (function (name) {
            return {
              TAG: /* Project_setup */ 32,
              _0: {
                TAG: /* Name */ 7,
                _0: name
              }
            };
          }), param);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
          return p.pending;
        }), source)));
        const partial_arg$2 = "Project name";
        const partial_arg$3 = "Project name";
        const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
          return p.name;
        }), source)));
        return function (param, param$1) {
          return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 8;
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    return p.target === undefined;
  }), source);
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___008_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (p) {
        return Stdlib__Option.fold("", (function (r) {
          return r.full_name;
        }), p.repository);
      }), source)));
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
    }),
    tl: {
      hd: branch_field(source, send),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___010_) {
            const partial_arg = {
              TAG: /* Project_setup */ 32,
              _0: /* Connect */ 5
            };
            const partial_arg$1 = (function (param) {
              return Lui_elements.press(send, partial_arg, param);
            });
            const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map((function (p) {
              return !Mapre_web__Web_project_model.can_connect(p);
            }), source)));
            const partial_arg$3 = "primary";
            const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map((function (p) {
              if (p.pending) {
                return "Saving...";
              } else if (p.target !== undefined) {
                return "Save repository connection";
              } else {
                return "Connect repository";
              }
            }), source)));
            return function (param, param$1) {
              return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$6 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$7 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.project_form, Mapre_web__Web_project_model.initial(""));
  }), model);
  const partial_arg = "Loading GitHub...";
  const partial_arg$1 = "muted";
  const partial_arg$2 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$3 = Signal.map((function (p) {
    return p.loading;
  }), source);
  const partial_arg$4 = account_picker(source, send);
  const partial_arg$5 = Signal.map((function (p) {
    return Mapre_web__Web_project_model.stage(p) === /* Accounts */ 0;
  }), source);
  const partial_arg$6 = repository_picker(source, send);
  const partial_arg$7 = Signal.map((function (p) {
    return Mapre_web__Web_project_model.stage(p) === /* Repositories */ 1;
  }), source);
  const partial_arg$8 = confirmation(source, send);
  const partial_arg$9 = Signal.map((function (p) {
    return Mapre_web__Web_project_model.stage(p) === /* Confirm */ 2;
  }), source);
  const partial_arg$10 = Signal.map((function (p) {
    return Mapre_web__Web_project_model.stage(p) !== /* Accounts */ 0;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$10, (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___013_) {
        const partial_arg = {
          TAG: /* Project_setup */ 32,
          _0: /* Back */ 4
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___013_.ui_scope, Signal.map((function (p) {
          return p.pending;
        }), source)));
        const partial_arg$3 = "ghost";
        const partial_arg$4 = "Back to selection";
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___014_) {
        const partial_arg = {
          TAG: /* Project_setup */ 32,
          _0: /* Close */ 0
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___014_.ui_scope, Signal.map((function (p) {
          return p.pending;
        }), source)));
        const partial_arg$3 = "ghost";
        const partial_arg$4 = "Cancel project connection";
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$11 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$12 = "wrap";
  const partial_arg$13 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___011_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___011_.ui_scope, Signal.map((function (p) {
        if (p.target === undefined) {
          return "Connect a project";
        } else {
          return "Update repository connection";
        }
      }), source)));
      const partial_arg$1 = 2;
      return function (param, param$1) {
        return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___012_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___012_.ui_scope, Signal.map((function (p) {
          if (p.target === undefined) {
            return "Only repositories you administer and have granted to this GitHub App can be connected.";
          } else {
            return "Select this project's repository after its transfer or rename. Its history and environment stay with the same repository.";
          }
        }), source)));
        const partial_arg$1 = "muted";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$9, partial_arg$8, param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.row(undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, partial_arg$11, param, param$1);
              }),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  };
  const partial_arg$14 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$15 = "form-card";
  const partial_arg$16 = 0;
  const partial_arg$17 = 16;
  const partial_arg$18 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
